/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minutes: NonNullable<unknown>, period: NonNullable<unknown> }} Signup_Feature_Starter_2Inputs */

const en_signup_feature_starter_2 = /** @type {(inputs: Signup_Feature_Starter_2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Automatic Captioning & transcription — ${i?.minutes} mins/${i?.period}*`)
};

const fr_signup_feature_starter_2 = /** @type {(inputs: Signup_Feature_Starter_2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Automatic Captioning & transcription — ${i?.minutes} mins/${i?.period}*`)
};

const de_signup_feature_starter_2 = /** @type {(inputs: Signup_Feature_Starter_2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Automatic Captioning & transcription — ${i?.minutes} mins/${i?.period}*`)
};

const it_signup_feature_starter_2 = /** @type {(inputs: Signup_Feature_Starter_2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Automatic Captioning & transcription — ${i?.minutes} mins/${i?.period}*`)
};

const ru_signup_feature_starter_2 = /** @type {(inputs: Signup_Feature_Starter_2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Automatic Captioning & transcription — ${i?.minutes} mins/${i?.period}*`)
};

const es_signup_feature_starter_2 = /** @type {(inputs: Signup_Feature_Starter_2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Automatic Captioning & transcription — ${i?.minutes} mins/${i?.period}*`)
};

const zh_cn2_signup_feature_starter_2 = /** @type {(inputs: Signup_Feature_Starter_2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Automatic Captioning & transcription — ${i?.minutes} mins/${i?.period}*`)
};

const ja_signup_feature_starter_2 = /** @type {(inputs: Signup_Feature_Starter_2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Automatic Captioning & transcription — ${i?.minutes} mins/${i?.period}*`)
};

const hi_signup_feature_starter_2 = /** @type {(inputs: Signup_Feature_Starter_2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Automatic Captioning & transcription — ${i?.minutes} mins/${i?.period}*`)
};

const pt_pt2_signup_feature_starter_2 = /** @type {(inputs: Signup_Feature_Starter_2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Automatic Captioning & transcription — ${i?.minutes} mins/${i?.period}*`)
};

/**
* | output |
* | --- |
* | "Automatic Captioning & transcription — {minutes} mins/{period}*" |
*
* @param {Signup_Feature_Starter_2Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_starter_2 = /** @type {((inputs: Signup_Feature_Starter_2Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Starter_2Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_signup_feature_starter_2(inputs)
	if (locale === "de") return de_signup_feature_starter_2(inputs)
	if (locale === "it") return it_signup_feature_starter_2(inputs)
	if (locale === "ru") return ru_signup_feature_starter_2(inputs)
	if (locale === "es") return es_signup_feature_starter_2(inputs)
	if (locale === "zh-CN") return zh_cn2_signup_feature_starter_2(inputs)
	if (locale === "ja") return ja_signup_feature_starter_2(inputs)
	if (locale === "hi") return hi_signup_feature_starter_2(inputs)
	if (locale === "pt-PT") return pt_pt2_signup_feature_starter_2(inputs)
	return en_signup_feature_starter_2(inputs)
});